import { render, staticRenderFns } from "./RdsPlayer.vue?vue&type=template&id=363faf38&scoped=true&"
import script from "./RdsPlayer.vue?vue&type=script&lang=js&"
export * from "./RdsPlayer.vue?vue&type=script&lang=js&"
import style0 from "./RdsPlayer.vue?vue&type=style&index=0&id=363faf38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363faf38",
  null
  
)

export default component.exports